import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { ItemState } from '@app/shared/enums/ItemState.enum';

@Pipe({
    name: "itemStatePipe",
    standalone: false
})
export class ItemStatePipe implements PipeTransform {
  public operationType = ItemState;
  public itemStateTypes: any[] = [];

  constructor(public translate: TranslateService) {
  }

  transform(key: any): any {
    for (let item in this.operationType) {
      if (this.operationType[item] === key)
        return this.translate.instant('ENUMS.ITEM_STATE_' + key);
    }
  }

  getList() {
    this.itemStateTypes = [];

    for (const [propertyKey, propertyValue] of Object.entries(ItemState)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.itemStateTypes.push({id: !!propertyValue, name: nameAndText, text: nameAndText});
    }

    return this.itemStateTypes;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ItemState)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return {id: propertyValue, name: nameAndText, text: nameAndText};
      }
    }
    return null
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ItemState)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null
  }
}
